/* TerraRest — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  if (window.__mtBooted) return;
  window.__mtBooted = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll (con salvaguardas anti-invisible) ---- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    function revealAll() { els.forEach(function (el) { el.classList.add('mt-visible'); }); }
    if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }

    var ioWorking = false;
    var io = new IntersectionObserver(function (entries) {
      ioWorking = true;
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // 1) Muestra ya lo que esté en pantalla (por si el observer tarda)
    var wh = window.innerHeight || 800;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < wh * 0.92) el.classList.add('mt-visible');
    });
    // 2) Salvaguarda: si el observer nunca dispara, muéstralo TODO
    setTimeout(function () { if (!ioWorking) revealAll(); }, 1200);
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count'); });
      return;
    }
    function run(el) {
      var target = parseFloat(el.getAttribute('data-mt-count')),
          dec = (el.getAttribute('data-mt-dec') || '0') | 0, dur = 1400, t0 = null;
      el.setAttribute('data-mt-done', '1');
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), val = (1 - Math.pow(1 - p, 3)) * target;
        el.textContent = val.toFixed(dec);
        if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
      }
      requestAnimationFrame(step);
    }
    var ioWorking = false;
    var io = new IntersectionObserver(function (entries) {
      ioWorking = true;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target); io.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
    // Salvaguarda: si el observer no dispara, muestra la cifra final
    setTimeout(function () {
      if (ioWorking) return;
      nums.forEach(function (n) {
        if (!n.getAttribute('data-mt-done')) n.textContent = parseFloat(n.getAttribute('data-mt-count')).toFixed((n.getAttribute('data-mt-dec') || '0') | 0);
      });
    }, 1300);
  }

  /* ---- Selector de color (sección colores) ---- */
  function initColorSwitch() {
    document.querySelectorAll('[data-mt-colors]').forEach(function (root) {
      var swatches = root.querySelectorAll('.mt-swatch');
      var imgs = root.querySelectorAll('.mt-colors__img');
      var nameOut = root.querySelector('.mt-swatch__name');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var idx = sw.getAttribute('data-idx');
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-idx') === idx); });
          if (nameOut) nameOut.textContent = sw.getAttribute('data-name') || '';
        });
      });
    });
  }

  /* ---- FAQ acordeón ---- */
  function initFaq() {
    document.querySelectorAll('.mt-faq__item').forEach(function (item) {
      var q = item.querySelector('.mt-faq__q'), a = item.querySelector('.mt-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---- Página de producto: galería + variantes ---- */
  function initGallery() {
    var gal = document.querySelector('[data-mt-gallery]');
    if (!gal) return;
    var main = gal.querySelector('.mt-gallery__main img');
    gal.querySelectorAll('.mt-gallery__thumb').forEach(function (th) {
      th.addEventListener('click', function () {
        var full = th.getAttribute('data-full');
        if (main && full) main.src = full;
        gal.querySelectorAll('.mt-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        th.classList.add('is-active');
      });
    });
  }

  function initVariants() {
    var form = document.querySelector('[data-mt-product-form]');
    if (!form) return;
    var dataEl = document.getElementById('mt-variant-data');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEls = document.querySelectorAll('[data-mt-price]');
    var compareEl = document.querySelector('[data-mt-compare]');
    var addBtn = form.querySelector('[data-mt-add]');
    var addLabel = addBtn ? addBtn.getAttribute('data-label') : 'Añadir al carrito';
    var soldLabel = addBtn ? addBtn.getAttribute('data-sold') : 'Agotado';
    var selected = {};

    function match() {
      return variants.find(function (vr) {
        return vr.options.every(function (o, i) { return selected[i] === o; });
      });
    }
    function update() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (p) { p.textContent = v.price; });
      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : soldLabel;
      }
    }
    form.querySelectorAll('[data-mt-opt]').forEach(function (group) {
      var oi = parseInt(group.getAttribute('data-mt-opt'), 10);
      var pills = group.querySelectorAll('.mt-opt__pill');
      pills.forEach(function (p) {
        if (p.classList.contains('is-active')) selected[oi] = p.getAttribute('data-value');
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.classList.remove('is-active'); });
          p.classList.add('is-active');
          selected[oi] = p.getAttribute('data-value');
          var out = group.querySelector('[data-mt-opt-out]');
          if (out) out.textContent = p.getAttribute('data-value');
          update();
          // Cambiar la imagen principal a la del color elegido (opción de color → miniatura del mismo índice)
          if (oi === 0) {
            var pillIdx = Array.prototype.indexOf.call(pills, p);
            var thumbs = document.querySelectorAll('[data-mt-gallery] .mt-gallery__thumb');
            if (thumbs[pillIdx]) thumbs[pillIdx].click();
          }
        });
      });
    });
    update();
  }

  /* ---- Selector de cantidad ---- */
  function initQty() {
    var box = document.querySelector('[data-mt-qty]');
    if (!box) return;
    var input = box.querySelector('.mt-qty__input');
    var dn = box.querySelector('[data-mt-qty-dn]');
    var up = box.querySelector('[data-mt-qty-up]');
    function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
    if (dn) dn.addEventListener('click', function () { input.value = Math.max(1, val() - 1); });
    if (up) up.addEventListener('click', function () { input.value = val() + 1; });
    input.addEventListener('change', function () { input.value = val(); });
  }

  /* ---- Barra fija de compra (móvil) ---- */
  function initStickyBar() {
    var bar = document.querySelector('[data-mt-stickybar]');
    var addBtn = document.querySelector('[data-mt-add]');
    if (!bar || !addBtn) return;
    var stickyAdd = bar.querySelector('[data-mt-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addBtn.click(); });
    function onScroll() {
      var r = addBtn.getBoundingClientRect();
      var show = r.bottom < 40; // el botón principal ya pasó arriba
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---- Hero: parallax con el cursor (profundidad) ---- */
  function initHeroParallax() {
    var hero = document.querySelector('.mt-hero--bleed');
    if (!hero) return;
    var bg = hero.querySelector('.mt-hero__bg');
    if (!bg) return;
    if (reduce) return;
    if (!(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;
    var raf = null, tx = 0, ty = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      tx = px * -16; ty = py * -11;
      if (!raf) raf = requestAnimationFrame(function () {
        bg.style.transform = 'scale(1.06) translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px)';
        raf = null;
      });
    });
    hero.addEventListener('mouseleave', function () { bg.style.transform = ''; });
  }

  /* ---- Selector de país/moneda (envía al cambiar) ---- */
  function initLocaleSelect() {
    var sel = document.querySelector('[data-mt-locale]');
    if (!sel || !sel.form) return;
    sel.addEventListener('change', function () { sel.form.submit(); });
  }

  /* ---- Smooth scroll robusto para anclas internas (#tr-...) ---- */
  function initAnchorScroll() {
    // Clic en la misma página: salto suave al ancla
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#tr-"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var id = href.slice(href.indexOf('#') + 1);
      var el = document.getElementById(id);
      if (!el) return; // ancla en otra página: deja navegar (lo resuelve el handler al cargar)
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    // Al cargar con un #tr- en la URL (llegando desde otra página): scroll manual
    if (location.hash && location.hash.indexOf('#tr-') === 0) {
      var hid = location.hash.slice(1);
      var go = function () {
        var el = document.getElementById(hid);
        if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
      };
      setTimeout(go, 80);
      window.addEventListener('load', function () { setTimeout(go, 40); });
    }
  }

  function boot() {
    initAnchorScroll();
    initReveals();
    initLocaleSelect();
    initCounters();
    initColorSwitch();
    initFaq();
    initGallery();
    initVariants();
    initQty();
    initStickyBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
